import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'

export default {
  methods: {
    showEdit (event) {
      const { data } = event || {}
      const { id } = data || {}

      const routerObject = {
        name: 'FleetTagView',
        params: {
          id
        }
      }

      routerObject.query = {}
      routerObject.query.tagName = data?.name ?? ''

      this.$router.push(routerObject).then()
    },

    onTagActivation (event) {
      const { deactivated_at: deactivatedAt, id, name } = event?.data || {}
      if (!id) {
        return
      }
      const title = !deactivatedAt ? this.$t('fleet/vehicle_tag.deactivate') : this.$t('fleet/vehicle_tag.activate')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'positiveBtnText', !deactivatedAt ? this.$t('base.deactivate') : this.$t('base.activate'))
      this.$set(this.informationDialogConfig, 'message', !deactivatedAt ? this.$t('fleet/vehicle_tag.confirm_deactivation') : this.$t('fleet/vehicle_tag.confirm_activation'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.tagActivation(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async tagActivation (event) {
      try {
        const { id, deactivated_at: deactivatedAt } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.vehicleTags || {}
        await api('fleet').patch(`vehicle-tags/${id}/${deactivatedAt ? 'activate' : 'deactivate'}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onTagDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/vehicle_tag.delete')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.tagDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async tagDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.vehicleTags || {}

        await api('fleet').delete(`vehicle-tags/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
